import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IVerifyPaymentScript } from '@/Module/Subscription/Model/ApiModel';
import SubscriptionService from '@/Module/Subscription/Service/SubscriptionService';

export const postVerifyPaymentRequestAction = createAsyncThunk<IVerifyPaymentScript, number>(
  'subscription/verify-payment',
  (req, { signal, rejectWithValue }) => {
    return SubscriptionService.postVerifyPaymentRequest(req, signal)
      .then(({ data }) => data.data)
      .catch(rejectWithValue);
  },
);
